
import { AssetEntityDecorator } from '../../asset/model/asset.decorator';
import { Asset } from '../../asset/model/asset.model';
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { CostCentreEntityDecorator } from '../../costcentre/model/cost-centre.decorator';
import { CostCentre } from '../../costcentre/model/cost-centre.model';
import { TRANSFER_ASSET_METADATA } from './transfer-asset.metadata';
import { TransferAsset } from './transfer-asset.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class TransferAssetEntityDecoratorBase extends GenericEntityDecorator<TransferAsset, number> {
  constructor() {
    super(TRANSFER_ASSET_METADATA, {
      get asset(): EntityDecorator<Asset, number> {
        return new AssetEntityDecorator();
      },
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      },
      get costCentre(): EntityDecorator<CostCentre, string> {
        return new CostCentreEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.transferAssetId == null) {
      return null;
    }
    return parseInt(params.transferAssetId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: TransferAsset): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




